export default function Footer() {
  return (
    <footer className="bg-light text-center py-3 mt-5">
      <small>© {new Date().getFullYear()} PAUD KB Cahaya Piradita Kaning. All rights reserved.</small>
    </footer>
  );
}
